import { Icon, Tooltip } from "@monta/design-system";
import styles from "./money.module.scss";
import { fixString } from "@monta/router-js";
import type { TUser } from "@monta/utils";

export interface MoneyProps {
  loginInfo?: TUser;
}

const Money = (props: MoneyProps) => {
  const { loginInfo } = props;

  return (
    <Tooltip text="پول">
      <div
        className={styles["money"]}
        onClick={() => {
          Object.assign(window.location, {
            href: fixString("/#!oldPopup;a144=wallet", "GWT_URL"),
          });
        }}
      >
        <span className={styles["money__value"]}>
          {loginInfo?.balance ? loginInfo.balance.toLocaleString() : 0}
        </span>
        <Icon
          icon={"mi-coin-charge"}
          size={1.5}
          className={styles["money__icon"]}
        />
      </div>
    </Tooltip>
  );
};

export default Money;
